import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
const FROM_KEY = "aisearch_from";
// The backend handles the OAuth callback at /api/auth/callback and 302s
// to the redirect URL directly. If a fallback path lands here (e.g., the
// SPA dev proxy didn't intercept the 302), hydrate the session and bounce
// to the deep-link URL preserved in sessionStorage.
export default function AuthCallback() {
    const { reload } = useAuth();
    const nav = useNavigate();
    useEffect(() => {
        let cancelled = false;
        (async () => {
            await reload();
            if (!cancelled) {
                const from = sessionStorage.getItem(FROM_KEY) || "/";
                sessionStorage.removeItem(FROM_KEY);
                nav(from, { replace: true });
            }
        })();
        return () => { cancelled = true; };
    }, [reload, nav]);
    return _jsx("div", { className: "centered", children: "Signing you in\u2026" });
}
